import { render, staticRenderFns } from "./OrderCountChart.vue?vue&type=template&id=b9716e4e&scoped=true"
import script from "./OrderCountChart.vue?vue&type=script&lang=js"
export * from "./OrderCountChart.vue?vue&type=script&lang=js"
import style0 from "./OrderCountChart.vue?vue&type=style&index=0&id=b9716e4e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9716e4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9716e4e')) {
      api.createRecord('b9716e4e', component.options)
    } else {
      api.reload('b9716e4e', component.options)
    }
    module.hot.accept("./OrderCountChart.vue?vue&type=template&id=b9716e4e&scoped=true", function () {
      api.rerender('b9716e4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/OrderCountChart.vue"
export default component.exports